module.exports = __webpack_public_path__ + "img/7_188.58e0dad0.png";